export const PROGRESS_TRACKER_SESSION_KEY = "isProgressAdmin";
export const PROGRESS_TRACKER_USERNAME = "ProgressAdmin";
export const PROGRESS_TRACKER_PASSWORD = "Progress2025";

export function isProgressTrackerAuthenticated() {
  return sessionStorage.getItem(PROGRESS_TRACKER_SESSION_KEY) === "true";
}

export function setProgressTrackerAuthenticated(value) {
  if (value) {
    sessionStorage.setItem(PROGRESS_TRACKER_SESSION_KEY, "true");
  } else {
    sessionStorage.removeItem(PROGRESS_TRACKER_SESSION_KEY);
  }
}

export function validateProgressTrackerLogin(username, password) {
  return (
    String(username).trim() === PROGRESS_TRACKER_USERNAME &&
    password === PROGRESS_TRACKER_PASSWORD
  );
}
